import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import ProfileInfoModalSkeleton from './Skeleton';
import { usePlayerStatistics } from '@/api/players';
import ProfileInfoUsername from './Username';

export default function ProfileInfo() {
  const { t } = useTranslation('common');
  const { player, isPending } = usePlayerStatistics();

  if (isPending || !player) {
    return <ProfileInfoModalSkeleton />;
  }

  return (
    <div className={styles.container}>
      <ProfileInfoUsername username={player?.username} userData={player} />
      <span className={styles.container__text}>
        {t('modalProfile_textID')} {player?.id.toString()}
      </span>
    </div>
  );
}
